import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
export function RoomSwitchOverlay(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  const t1 = className ?? "fixed inset-0";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("z-[100] flex items-center justify-center bg-background/50", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-8 w-8 animate-spin rounded-full border-4 border-border border-t-transparent" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <div className={t2} data-sentry-component="RoomSwitchOverlay" data-sentry-source-file="RoomSwitchOverlay.tsx">{t3}</div>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}